import { useEffect, useState } from "react";
import { IDashboardStats } from "../../models/DashboardStats";
import DashboardTile from "./DashboardTile";
import DashboardStatTableTabs from "../shared/Tabs/DashboardStatTableTabs";

const tabs = [
  { name: 'Today', value: 'today' },
  { name: 'Week', value: 'week' },
  { name: 'Month', value: 'month' },
]

export default function LeadsBookedTable({ dashboardStats }: { dashboardStats: IDashboardStats }) {
  const [timeframe, setTimeframe] = useState("today");
  const [stats, setStats] = useState<{ [key: string]: number } | undefined>(undefined);

  useEffect(() => {
    if (dashboardStats) {
      switch (timeframe) {
        case "today":
          setStats(dashboardStats.bookedDay);
          break;
        case "week":
          setStats(dashboardStats.bookedWeek);
          break;
        case "month":
          setStats(dashboardStats.bookedMonth);
          break;
      }
    }
  }, [dashboardStats, timeframe])

  return (
    <DashboardTile span={2}>
      <div className="p-3">
        <div className="mb-3 w-full flex justify-between">
          <div className="prose">
            <h3>Leads booked</h3>
          </div>
          
          <DashboardStatTableTabs
            tabs={tabs}
            value={timeframe}
            onChange={setTimeframe}
            ariaLabel="Select a tab"
          />

        </div>

        <div className="mt-6">
          <div className="flex justify-between">
            <p>User</p>
            <p>Booked</p>
          </div>

          <hr />

          <div className="mt-4 flex flex-col divide-y gap-y-2">
            {stats && Object.keys(stats).map((key) => {
              if (stats[key] !== 0) {
              return (
                <div key={key} className="flex justify-between pt-2 font-semibold">
                  <p className="">{key}</p>
                  <p className="font-bold text-xl text-primary-600">{stats[key]}</p>
                </div>
              )
              }
            })}
          </div>
        </div>

      </div>
    </DashboardTile>
  )

}